module.exports = __webpack_public_path__ + "img/logoP.f8956bea.jpg";